module.exports = __webpack_public_path__ + "img/20.a600b7cd.png";